import React, { MutableRefObject } from 'react';
import { isEmpty } from 'lodash';
import { TeamMember } from '@zonofi/zono-money-store';
import { View } from '../../common';
import {
  CustomerSkeleton,
  EmptyStateView,
  EndListView,
  SpinnerLoader,
} from '../../components';
import { SVGS } from '../../assets';
import { TeamMemberCard } from './team-member-card';
import './team-members-list.scss';

interface TeamMembersListProps {
  isloading?: boolean;
  teamMembersData: TeamMember[];
  lastItemRef: MutableRefObject<HTMLDivElement | null>;
  isEndOfList?: boolean;
  onTeamMemberSelect?: (teamMember: TeamMember) => void;
  selectedTeamMemberIds?: string[];
}

export const TeamMembersList: React.FC<TeamMembersListProps> = ({
  isloading = false,
  teamMembersData = [],
  lastItemRef,
  isEndOfList = false,
  onTeamMemberSelect,
  selectedTeamMemberIds = [],
}) => {
  return isloading ? (
    <CustomerSkeleton className="team-members-list-skeleton-view" />
  ) : (
    <View className="team-members-list-container">
      {isEmpty(teamMembersData) ? (
        <EmptyStateView
          imageSrc={SVGS.NoTeamMembers}
          message="No Team Members Found"
        />
      ) : (
        <>
          {teamMembersData.map((teamMember, index) => (
            <TeamMemberCard
              key={teamMember?.id}
              teamMember={teamMember}
              isFirst={index === 0}
              isLast={index === teamMembersData.length - 1}
              isSelected={selectedTeamMemberIds.includes(teamMember?.id)}
              onSelect={onTeamMemberSelect}
            />
          ))}
          <div ref={lastItemRef} className="team-members-last-item" />
          {!isEndOfList && <SpinnerLoader />}
          {isEndOfList && <EndListView />}
        </>
      )}
    </View>
  );
};
